import { useStaticQuery, graphql } from 'gatsby'

export const useXPinsQuery = () => {
  const { wp, site } = useStaticQuery(graphql`
    query XPinsQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            xPins {
              serviceAreasTitle
              serviceAreasSubtitle
              accordionTitle
              locationIcon {
                sourceUrl
              }
              carrotIcon {
                sourceUrl
              }
              pinIcon {
                sourceUrl
              }
              services {
                serviceTitle
                counties {
                  county
                  towns
                }
              }
              cardsTitle
              cardsAuthor
              defaultCardImage {
                sourceUrl
                mediaDetails {
                  width
                  height
                }
              }
              defaultLatitude
              defaultLongitude
              defaultCardData {
                date
                content
                image {
                  sourceUrl
                }
              }
            }
            footer {
              socialMedia {
                socialMediaLink {
                  url
                }
              }
            }
          }
        }
        nexvelSchemaMarkup {
          nexvelschema {
            businessType
            businessName
            streetAddress
            city
            state
            zipCode
          }
        }
      }
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  return { wp, site }
}
